import { cn } from "@/helper/HelperFunction";
import classes from "./Statuses.module.css";

export default function Statuses({ status, isLabel = true }) {
  const statusesColor = {
    active: {
      color: "#00AF26",
      label: "Active",
    },
    inactive: {
      color: "#F53649",
      label: "Suspended",
    },
    "system-deactivated": {
      color: "#F53649",
      label: "In-Active",
    },
    deactivated: {
      color: "#F53649",
      label: "In-Active",
    },
    cancelled: {
      color: "#F53649",
      label: "Cancelled",
    },
    pending: {
      color: "#F59E0B",
      label: "Pending",
    },
    rejected: {
      color: "#F04438",
      label: "Rejected",
    },
    accepted: {
      color: "#479F78",
      label: "Accepted",
    },
    "pending-verification": {
      color: "#F59E0B",
      label: "Unverified",
    },
  };
  return (
    <div
      className={cn(classes.statusWrapper, !isLabel && classes.withoutLabel)}
      style={{
        "--indicator-color": statusesColor[status]?.color,
        backgroundColor: `${statusesColor[status]?.bgColor}`,
      }}
    >
      {isLabel && (
        <p style={{ color: statusesColor[status]?.color }}>
          {statusesColor[status]?.label}
        </p>
      )}
    </div>
  );
}
